/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFDomainsBlocklistRecord
 */
export interface CRSFDomainsBlocklistRecord {
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    asset: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    category: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsBlocklistRecord
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsBlocklistRecord
     */
    last_found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    root_domain: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    service: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFDomainsBlocklistRecord
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    source_list_name: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFDomainsBlocklistRecord
     */
    subcategory: string;
}

/**
 * Check if a given object implements the CRSFDomainsBlocklistRecord interface.
 */
export function instanceOfCRSFDomainsBlocklistRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "last_found" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "root_domain" in value;
    isInstance = isInstance && "service" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source_list_name" in value;
    isInstance = isInstance && "subcategory" in value;

    return isInstance;
}

export function CRSFDomainsBlocklistRecordFromJSON(json: any): CRSFDomainsBlocklistRecord {
    return CRSFDomainsBlocklistRecordFromJSONTyped(json, false);
}

export function CRSFDomainsBlocklistRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainsBlocklistRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'created': json['created'],
        'last_found': json['last_found'],
        'region': json['region'],
        'root_domain': json['root_domain'],
        'service': json['service'],
        'shared': json['shared'],
        'source_list_name': json['source_list_name'],
        'subcategory': json['subcategory'],
    };
}

export function CRSFDomainsBlocklistRecordToJSON(value?: CRSFDomainsBlocklistRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'created': value.created,
        'last_found': value.last_found,
        'region': value.region,
        'root_domain': value.root_domain,
        'service': value.service,
        'shared': value.shared,
        'source_list_name': value.source_list_name,
        'subcategory': value.subcategory,
    };
}

